const SERVICE_WORKER_PATH = '/sw.js'

export const NOTIFICATION_CLICK_MESSAGE = 'notification-click'

export interface IBrowserNotification {
  title: string
  body: string
  tag: string
  url: string
}

export const canNotify = () => typeof window !== 'undefined' && 'Notification' in window

let registrationPromise: Promise<ServiceWorkerRegistration | null> | null = null

export const registerNotificationWorker = () => {
  if (registrationPromise) return registrationPromise
  if (!('serviceWorker' in navigator)) {
    registrationPromise = Promise.resolve(null)
    return registrationPromise
  }

  registrationPromise = navigator.serviceWorker
    .register(SERVICE_WORKER_PATH)
    // ready, а не результат register: свежезарегистрированный воркер ещё не активен,
    // а показывать уведомления умеет только активный
    .then(() => navigator.serviceWorker.ready)
    .catch(() => null)

  return registrationPromise
}

export const showBrowserNotification = async ({ title, body, tag, url }: IBrowserNotification) => {
  if (!canNotify() || Notification.permission !== 'granted') return

  const options: NotificationOptions = { body, tag, icon: '/favicon.ico', data: { url } }
  const registration = await registerNotificationWorker()

  if (registration) {
    await registration.showNotification(title, options)
    return
  }

  // Запасной путь для браузеров без воркеров: на телефонах конструктор бросит TypeError
  try {
    const notification = new Notification(title, options)
    notification.onclick = () => {
      window.focus()
      window.location.assign(url)
      notification.close()
    }
  } catch {
    // показать уведомление нечем
  }
}
